const EVENT_FIRST_INTERACTION = "fpo:first-interaction";
const EVENT_REPLAY_CAPTURED_EVENTS = "fpo:replay-captured-events";
const EVENT_LCP_ELEMENT = "fpo:lcp-element";
const EVENT_LCP_ELEMENT_CANDIDATE = "fpo:lcp-element-candidate";
const EVENT_LCP_LOADED = "fpo:lcp-loaded";
const EVENT_LAZY_ELEMENT = "fpo:lazy-element";
const EVENT_STYLES_TAG_AVAILABLE = "fpo:styles-tag-available";
const EVENT_CSS_LOADED = "fpo:css-loaded";
const EVENT_ELEMENT_LOADED = "fpo:element-loaded";
const EVENT_IMAGES_LOADED = "fpo:images-loaded";
const EVENT_THE_END = "fpo:the-end";
const EVENT_SCROLL_TO_REVEAL_ANIMATIONS = "fpo:scroll-to-reveal-animations";

export {
    EVENT_LCP_ELEMENT,
    EVENT_LCP_ELEMENT_CANDIDATE,
    EVENT_LCP_LOADED,
    EVENT_LAZY_ELEMENT,
    EVENT_STYLES_TAG_AVAILABLE,
    EVENT_FIRST_INTERACTION, 
    EVENT_REPLAY_CAPTURED_EVENTS,
    EVENT_CSS_LOADED,
    EVENT_ELEMENT_LOADED,
    EVENT_IMAGES_LOADED,
    EVENT_THE_END,
    EVENT_SCROLL_TO_REVEAL_ANIMATIONS,
};
